import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import type { DocumentType } from '../../graphql/generated/gql';

export type ExtractReactionThreadTypes<
  TDocumentNode extends DocumentNode<unknown, unknown>,
> = Extract<
  DocumentType<TDocumentNode>,
  { __typename?: 'ReactionThread' } | { __typename?: 'PublicReactionThread' }
>;

export type ExtractCommentThreadTypes<
  TDocumentNode extends DocumentNode<unknown, unknown>,
> = Extract<
  DocumentType<TDocumentNode>,
  { __typename?: 'CommentThread' } | { __typename?: 'PublicCommentThread' }
>;

export function isReactionOrPublicReactionThread<
  T extends { __typename?: string },
>(thread: T) {
  return (
    isThreadType(thread, 'ReactionThread') ||
    isThreadType(thread, 'PublicReactionThread')
  );
}

export function isCommentOrPublicCommentThread<
  T extends { __typename?: string },
>(thread: T) {
  return (
    isThreadType(thread, 'CommentThread') ||
    isThreadType(thread, 'PublicCommentThread')
  );
}

function isThreadType<
  Thread extends { __typename?: string },
  Type extends string,
>(thread: Thread, type: Type): thread is Thread & { __typename: Type } {
  return thread.__typename === type;
}
